import { dynamicConfigNames } from '@mp/constants';
import { useDynamicConfig } from '@mp/hooks';

export const useSchedulingPrefsConfig = () => {
  const config = useDynamicConfig(dynamicConfigNames.schedulingPrefsConfig);

  const preferences = config.get('preferences', {}) as Record<string, boolean>;

  return {
    shiftPreferences: preferences.shift_preferences ?? false,
    dayPreferences: preferences.day_preferences ?? false,
    frequencyPreferences: preferences.frequency_preferences ?? false,
    positionPreferences: preferences.position_preferences ?? false,
  };
};
